import { ResultSet } from "@cubejs-client/core";
import { AppThunk } from "appThunk";
import { PinnedLocation } from "modules/customer/tools/location/pinnedLocation";
import { cubeLoad } from "modules/helpers/cube/cubeSlice";
import { logError } from "modules/helpers/logger/loggerSlice";

export class FootfallByArea {
    public readonly cellId: string;
    public readonly numberOfVisits: number;
    public readonly dwellTime: number;

    constructor(
        cellId: string,
        numberOfVisits: number,
        dwellTime: number
    ) {
        this.cellId = cellId;
        this.numberOfVisits = numberOfVisits;
        this.dwellTime = dwellTime;
    }
}

export const loadFootfallByArea = (pinnedLocation: PinnedLocation | undefined): AppThunk<Promise<FootfallByArea[]>> => async (dispatch) => {
    try {
        if (!pinnedLocation) {
            return [];
        }
        const query = {
            dimensions: [
                "Footfall_Cell_Annual.L10IntId",
                "Footfall_Cell_Annual.FootfallCount",
                "Footfall_Cell_Annual.DwellTime"
            ],
            filters: [{
                member: "Footfall_Cell_Annual.RetailCentreID",
                operator: "equals",
                values: [String(pinnedLocation.retailCentre.id)]
            }]
        };
        const resultSet = await dispatch(cubeLoad(query)) as unknown as ResultSet;
        return resultSet.rawData().map(row => {
            return new FootfallByArea(
                String(row["Footfall_Cell_Annual.L10IntId"]),
                Number(row["Footfall_Cell_Annual.FootfallCount"]),
                Number(row["Footfall_Cell_Annual.DwellTime"])
            );
        });
    } catch (error) {
        dispatch(logError("Error loading FootfallCentile.", error));
        throw error;
    }
};
